/* eslint-disable @typescript-eslint/no-explicit-any */
import { CreateToasterReturn } from '@chakra-ui/react';
import { IdTokenResult } from 'firebase/auth';
import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime';
import { Dispatch } from 'react';
import { usePageError } from '~/hooks/store';
import { logout } from '~/hooks/store/logout';
import { parseReturnUrl } from '~/lib/parse';
import { findErrorCodeDescription, isArcApiError } from '~/src/services/errors';
import { getArcApiUser } from '~/src/services/users';
import { ActionType } from '~/types';

export const loginHandler = {
  success: async (
    return_url: string | null,
    t: (prefix: any, obj?: any) => string,
    dispatch: Dispatch<ActionType>,
    router: AppRouterInstance,
    toaster: CreateToasterReturn,
    token: IdTokenResult | null
  ) => {
    if (token == null) return;

    dispatch({
      type: 'SET_TOKEN',
      payload: {
        token: token,
      },
    });

    const loginRes = await getArcApiUser(token.token);

    if (loginRes?.status == 200) {
      toaster.success({
        title: t('global.login.success'),
        duration: 2000,
      });
      return_url
        ? router.replace(parseReturnUrl(decodeURIComponent(return_url)))
        : router.replace('/e');
    } else {
      logout();
      if (isArcApiError(loginRes?.body)) {
        const error = findErrorCodeDescription(loginRes?.body.code);
        toaster.error({
          title: error?.title,
          description: error?.description,
          duration: 9000,
        });
      } else {
        toaster.error({
          title: t('global.login.error.title'),
          description: t('global.login.error.description'),
          duration: 9000,
        });
      }
    }
  },
  failure: (t: (prefix: any, obj?: any) => string) => {
    const { setPageError: PageError } = usePageError();
    logout();
    PageError({
      title: t('global.login.error.title'),
      body: t('global.login.error.description'),
    });
  },
};
